import { IframeHeight } from './../../models/types'
import { WidgetMode } from '../../models/enums'
import themeVars from '../../themes/themeContract.css'
import { Screens } from 'patient-api-lib'

export const calculateContainerHeight = (
  mode: WidgetMode | null | undefined,
  iframeHeight: IframeHeight
) => {
  if (mode === WidgetMode.Embedded && iframeHeight) {
    return themeVars.widgetDimensions.height
  }

  return 'auto'
}

export const showScreenHeader = (
  mode: WidgetMode | null | undefined,
  initialScreen: Screens,
  currentScreen: Screens | null
) => {
  const disableOnScreens = [
    initialScreen,
    Screens.BookingConfirmationScreen,
    Screens.YourBookingsScreen,
    Screens.TokenizationScreen,
  ]
  const isModalMode = mode === WidgetMode.Modal
  const isEmbeddedMode = mode === WidgetMode.Embedded

  if (isModalMode) {
    return true
  }

  if (!currentScreen) {
    return false
  }

  if (isEmbeddedMode && !disableOnScreens.includes(currentScreen)) {
    return true
  }

  return false
}
